import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import './index.css';
import { App } from './views/App';
import { ActivityProvider, MessageProvider, ModalProvider, NotificationProvider, TooltipProvider } from "./context";
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <MessageProvider>
    <TooltipProvider>
      <ModalProvider>
        <NotificationProvider>
          <ActivityProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ActivityProvider>
        </NotificationProvider>
      </ModalProvider>
    </TooltipProvider>
  </MessageProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
